const TIMEZONES = [
  { label: "Hawaii (HST)",                          value: "Hawaii",                      iana: "Pacific/Honolulu" },
  { label: "Alaska (AKST/AKDT)",                    value: "Alaska",                      iana: "America/Anchorage" },
  { label: "Pacific Time — US & Canada (PST/PDT)",  value: "Pacific Time (US & Canada)",  iana: "America/Los_Angeles" },
  { label: "Arizona (MST, no DST)",                 value: "Arizona",                     iana: "America/Phoenix" },
  { label: "Mountain Time — US & Canada (MST/MDT)", value: "Mountain Time (US & Canada)", iana: "America/Denver" },
  { label: "Central Time — US & Canada (CST/CDT)",  value: "Central Time (US & Canada)",  iana: "America/Chicago" },
  { label: "Eastern Time — US & Canada (EST/EDT)",  value: "Eastern Time (US & Canada)",  iana: "America/New_York" },
  { label: "Atlantic Time — Canada (AST/ADT)",      value: "Atlantic Time (Canada)",      iana: "America/Halifax" },
  { label: "Newfoundland (NST/NDT)",                value: "Newfoundland",                iana: "America/St_Johns" },
  { label: "Brasilia (BRT/BRST)",                   value: "Brasilia",                    iana: "America/Sao_Paulo" },
  { label: "Buenos Aires (ART)",                    value: "Buenos Aires",                iana: "America/Argentina/Buenos_Aires" },
  { label: "Mexico City (CST/CDT)",                 value: "Mexico City",                 iana: "America/Mexico_City" },
  { label: "London (GMT/BST)",                      value: "London",                      iana: "Europe/London" },
  { label: "Dublin (GMT/IST)",                      value: "Dublin",                      iana: "Europe/Dublin" },
  { label: "Lisbon (WET/WEST)",                     value: "Lisbon",                      iana: "Europe/Lisbon" },
  { label: "Paris (CET/CEST)",                      value: "Paris",                       iana: "Europe/Paris" },
  { label: "Berlin (CET/CEST)",                     value: "Berlin",                      iana: "Europe/Berlin" },
  { label: "Amsterdam (CET/CEST)",                  value: "Amsterdam",                   iana: "Europe/Amsterdam" },
  { label: "Madrid (CET/CEST)",                     value: "Madrid",                      iana: "Europe/Madrid" },
  { label: "Rome (CET/CEST)",                       value: "Rome",                        iana: "Europe/Rome" },
  { label: "Athens (EET/EEST)",                     value: "Athens",                      iana: "Europe/Athens" },
  { label: "Helsinki (EET/EEST)",                   value: "Helsinki",                    iana: "Europe/Helsinki" },
  { label: "Istanbul (TRT)",                        value: "Istanbul",                    iana: "Europe/Istanbul" },
  { label: "Moscow (MSK)",                          value: "Moscow",                      iana: "Europe/Moscow" },
  { label: "Dubai (GST)",                           value: "Abu Dhabi",                   iana: "Asia/Dubai" },
  { label: "Riyadh (AST)",                          value: "Riyadh",                      iana: "Asia/Riyadh" },
  { label: "Mumbai / Kolkata (IST)",                value: "Mumbai",                      iana: "Asia/Kolkata" },
  { label: "Dhaka (BST)",                           value: "Dhaka",                       iana: "Asia/Dhaka" },
  { label: "Bangkok (ICT)",                         value: "Bangkok",                     iana: "Asia/Bangkok" },
  { label: "Singapore (SGT)",                       value: "Singapore",                   iana: "Asia/Singapore" },
  { label: "Hong Kong (HKT)",                       value: "Hong Kong",                   iana: "Asia/Hong_Kong" },
  { label: "Beijing / Shanghai (CST)",              value: "Beijing",                     iana: "Asia/Shanghai" },
  { label: "Taipei (CST)",                          value: "Taipei",                      iana: "Asia/Taipei" },
  { label: "Seoul (KST)",                           value: "Seoul",                       iana: "Asia/Seoul" },
  { label: "Tokyo (JST)",                           value: "Tokyo",                       iana: "Asia/Tokyo" },
  { label: "Perth (AWST)",                          value: "Perth",                       iana: "Australia/Perth" },
  { label: "Sydney (AEST/AEDT)",                    value: "Sydney",                      iana: "Australia/Sydney" },
  { label: "Melbourne (AEST/AEDT)",                 value: "Melbourne",                   iana: "Australia/Melbourne" },
  { label: "Auckland (NZST/NZDT)",                  value: "Auckland",                    iana: "Pacific/Auckland" },
];

// The backend stores timezones using Rails names (e.g. "Pacific Time (US & Canada)").
// The browser and Chart.js use IANA names (e.g. "America/Los_Angeles").
// These maps convert between the two formats.
const RAILS_TO_IANA = Object.fromEntries(TIMEZONES.map((tz) => [tz.value, tz.iana]));
const IANA_TO_RAILS = Object.fromEntries(TIMEZONES.map((tz) => [tz.iana, tz.value]));

export function railsToIana(railsName) {
  return RAILS_TO_IANA[railsName] || Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function resolveToIana(timezone) {
  return RAILS_TO_IANA[timezone] || timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function formatTimestampForDisplay(value, timezone) {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  const timeZone = resolveToIana(timezone);
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZoneName: "short",
  }).formatToParts(date);

  const get = (type) => parts.find((part) => part.type === type)?.value || "";
  return `${get("year")}-${get("month")}-${get("day")} ${get("hour")}:${get("minute")} ${get("dayPeriod")} ${get("timeZoneName")}`.trim();
}

export function formatPriceUpdatedAt(formattedValue, isoValue, timezone) {
  return formatTimestampForDisplay(isoValue, timezone) || formattedValue || null;
}

export function ianaToRails(ianaName) {
  return IANA_TO_RAILS[ianaName] || null;
}

export function browserTimezoneRails() {
  const browserIana = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return ianaToRails(browserIana) || 'Pacific Time (US & Canada)';
}

export function browserPreferenceSignals() {
  let ianaTimezone = null;
  let railsTimezone = null;

  try {
    ianaTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    railsTimezone = ianaToRails(ianaTimezone) || browserTimezoneRails();
  } catch (error) {
    railsTimezone = 'Pacific Time (US & Canada)';
  }

  const browserNavigator = typeof navigator !== "undefined" ? navigator : {};
  const languages = Array.isArray(browserNavigator.languages) ? browserNavigator.languages : [];
  const locale = browserNavigator.language || languages[0] || null;

  return {
    railsTimezone,
    ianaTimezone,
    locale,
  };
}

export default TIMEZONES;
